<template>
  <div class="card" style='width: 960px'
    v-if="!chargement">
    <header class="bandeau-modal card-header">
    </header>
    <section class="card-content pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-40px">
            <h1 class="title is-size-3">
              <span v-if="modeModification">
                {{ $t('demandeLogistique.creationOrUpdate.titleUpdateIntervention') }}
              </span>
              <span v-else>
                {{ $t('demandeLogistique.creationOrUpdate.titleCreateIntervention') }}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div class="pdl-0 pdr-0 max-height-700">
        <error-msg-component
          :messages="messages"
          :error="error"
          :messagesChampsVide="messagesChampsVide"
          :champsVide="champsVide"
          :withEmplyFields="true"
          title="general.problemOccurred"
          @close="error = $event"/>
        <onglet-manager
          class="mgt-20px"
          :onglets="onglets">
          <template #informations>
            <informations
              :creationDemandeParametre="creationDemandeParametre"
              :typesOT="typesOT"
              :commande="commande"
              :isProduitIsDivers="isProduitIsDivers"
              :doAnnonceursHasEmplacementClient="doAnnonceursHasEmplacementClient"
              :isInterventionTypeTechnique="isInterventionTypeTechnique"
              :demandeLogistique="demandeLogistique"
              :listeFacesBase="listeFacesBase"
              @updateCreationDemandeParametre="updateCreationDemandeParametre"
              @onDatePlanificationChange="handleDatePlanificationChange"
            />
          </template>
          <template #faces>
            <tab-select-faces-demande-logistique
              :listeFacesBase="listeFacesBase"
              :displayColumnLogistique="true"
              @selectFaces="handleSelectedFaces"
            />
          </template>
        </onglet-manager>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="sauvegarde()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </section>
  </div>
</template>
<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { createAll, update } from '@/api/logistique/demandeLogistique/index';
import { get as getCommande } from '@/api/commande';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import gestionDateBase from '@/services/general/gestionDateBase';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/logistique/demandeLogistique/validation';
import translate from '@/services/logistique/demandeLogistique/translator';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import * as interventionConf from '@/configuration/logistique/intervention/interventionConf';
import { COMMERCIAL, ASSISTANT_COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import {
  CATEGORIE_DIVERS,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
} from '@/configuration/catalogue/produitConf';
import { getAll as getAllEmplacement } from '@/api/gabed/emplacement';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { CLIENT } from '@/configuration/gabed/emplacement/emplacementConf';
import Informations from '@/components/commande/logistique/editionDemandeInformations';
import { GUID_VIDE } from '@/configuration/general';
import { getLignesSelectionFaceForDemandeAffichage } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import ongletManager from '@/components/general/ongletManager';
import tabSelectFacesDemandeLogistique
  from '@/components/devisCommandeFacture/facesSelectInReseauTempo/tabSelectFacesDemandeLogistique';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_creationDemande',
  props: {
    lignesCommande: {
      type: Array,
      required: false,
    },
    demandeLogistique: {
      type: Object,
      required: false,
    },
    demandeurId: {
      type: Number,
    },
    devisCommandeIdFromLigne: {
      type: String,
      requeired: false,
    },
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      listeFacesBase: [],
      creationDemandeParametre: {
        datePlanification: moment().toDate(),
        actionLogistique: '',
        ordreRealisation: '',
        type: interventionConf.INTERVENTION_TYPE_AFFICHAGE,
        typeOtId: null,
        emplacementId: null,
        dispositifId: null,
        materielId: null,
        faceId: null,
        source: interventionConf.SOURCE_VENTE,
        adresse: null,
        demandeurId: null,
      },
      chargement: false,
      constantes: {
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
        ASSISTANT_COMMERCIAL,
        INTERVENTION_TYPE_INTERVENTION: interventionConf.INTERVENTION_TYPE_INTERVENTION,
        NO_PAGINATION,
      },
      commande: null,
      doAnnonceursHasEmplacementClient: false,
    };
  },
  components: {
    errorMsgComponent,
    Informations,
    tabSelectFacesDemandeLogistique,
    ongletManager,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    onglets() {
      const tabs = [
        {
          key: 'informations',
          title: this.$t('demandeLogistique.creationOrUpdate.tab.informations'),
        },
      ];
      if (this.displaySelectionFaces) {
        tabs.push({
          key: 'faces',
          title: this.$t('demandeLogistique.creationOrUpdate.tab.faces', { nbrFacesSelected: this.nbrFacesSelected }),
        });
      }
      return tabs;
    },
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    modeModification() {
      return !!this.demandeLogistique;
    },
    isInterventionTypeTechnique() {
      return this.creationDemandeParametre.type
        === interventionConf.INTERVENTION_TYPE_INTERVENTION;
    },
    isAffichage() {
      return this.creationDemandeParametre.type
        === interventionConf.INTERVENTION_TYPE_AFFICHAGE;
    },
    isProduitIsDivers() {
      return this.demandeLogistique?.typeProduit === CATEGORIE_DIVERS
        || this.lignesCommande?.every(ligne => ligne?.produit.produitDivers !== null);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    displaySelectionFaces() {
      const regroupement = [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_LC,
        CATEGORIE_REGROUPEMENT_MAIRIE,
      ];
      return regroupement.includes(
        this.demandeLogistique?.typeProduit ?? this.lignesCommande[0]?.typeProduit,
      ) && this.isAffichage;
    },
    nbrFacesSelected() {
      const nbr = this.listeFacesBase.filter(f => f.selected).length;
      return nbr ? `(${nbr})` : '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    handleDatePlanificationChange() {
      this.initSelFaces();
    },
    cleanPatrimmoineData() {
      this.creationDemandeParametre.adresse = null;
      this.creationDemandeParametre.emplacementId = null;
      this.creationDemandeParametre.dispositifId = null;
      this.creationDemandeParametre.materielId = null;
      this.creationDemandeParametre.faceId = null;
    },
    cleanInterventionTypeData() {
      if (this.isInterventionTypeTechnique) return;
      this.creationDemandeParametre.typeOtId = null;
      this.creationDemandeParametre.demandeurId = null;
      this.cleanPatrimmoineData();
    },
    async sauvegarde() {
      this.cleanInterventionTypeData();
      if (this.modeModification) {
        await this.updateDemande();
        return;
      }
      await this.createDemande();
    },
    async updateDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandeAUpdate = cloneDeep(this.creationDemandeParametre);
        if (!!demandeAUpdate.dispositifId
          || !!demandeAUpdate.materielIdId
          || !!demandeAUpdate.face) {
          demandeAUpdate.emplacementId = null;
        }
        demandeAUpdate.datePlanification = formatDate(demandeAUpdate.datePlanification);
        if (!this.isAffichage) {
          delete demandeAUpdate.demandeLogistiqueSelProduit;
        }
        const demandeRetour = (await update(demandeAUpdate)).data.result;
        demandeRetour.datePlanification = formatDate(demandeRetour.datePlanification);
        messageSucces(this.$t('demandeLogistique.creationOrUpdate.success'));
        loadingComponent.close();
        this.$emit('refreshList', demandeRetour);
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async createDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = this.lignesCommande.map(ligne => ({
          ...this.creationDemandeParametre,
          datePlanification: formatDate(this.creationDemandeParametre.datePlanification),
          ligneCommandeId: ligne.id,
          agenceId: ligne.produit.agenceId || this.agencesSelectionnees[0].agenceId,
        }));
        if (!this.isAffichage) {
          delete params.demandeLogistiqueSelProduit;
        }
        const retourCreation = (await createAll(params)).data.result;
        retourCreation.forEach(retour => {
          const ligne = this.lignesCommande.find(l => l.id === retour.ligneCommandeId);
          if (!ligne) return;
          ligne.demandesLogistique.push(retour);
        });
        if (retourCreation.length > 1) {
          messageSucces(this.$t('demandeLogistique.creationOrUpdate.successMulti'));
        } else {
          messageSucces(this.$t('demandeLogistique.creationOrUpdate.success'));
        }
        loadingComponent.close();
        this.$parent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    updateCreationDemandeParametre(value) {
      this.creationDemandeParametre = value;
    },
    handleSelectedFaces(faces) {
      if (faces) {
        this.creationDemandeParametre.demandeLogistiqueSelProduit = cloneDeep(faces)
          .filter(face => face.selected === true)
          .map(face => {
            const dmdLogistiqueSelProduit = this.demandeLogistique?.demandeLogistiqueSelProduit
              .find(d => d.produitId === face.produitId);
            return {
              produitId: face.produitId,
              estDisponible: face.dispo,
              ...(this.modeModification && { id: dmdLogistiqueSelProduit?.id ?? GUID_VIDE }),
            };
          });
      }
    },
    async initSelFaces() {
      if (!this.displaySelectionFaces) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        const users = this.parametre(PARAMETRES_KEYS.utilisateur);
        let liste = [];
        if (this.demandeLogistique) {
          liste = await getLignesSelectionFaceForDemandeAffichage(this.demandeLogistique,
            users, this.societeActiveId,
            this.creationDemandeParametre.datePlanification);
        } else {
          const newDemande = {
            typeProduit: this.lignesCommande[0].typeProduit,
            ligneCommande: this.lignesCommande[0],
          };
          liste = await getLignesSelectionFaceForDemandeAffichage(newDemande,
            users, this.societeActiveId,
            this.creationDemandeParametre.datePlanification);
        }
        liste.sort((a, b) => a.affecteLogistiquement - b.affecteLogistiquement);
        this.listeFacesBase = liste
          .map(face => {
            if (this.modeModification) {
              const dmdLogistiqueSelProduit = this.demandeLogistique?.demandeLogistiqueSelProduit
                .find(f => f.produitId === face.produitId
                  && f.demandeLogistiqueId === this.demandeLogistique?.id,
                );
              if (dmdLogistiqueSelProduit) face.selected = true;
              else face.selected = false;
            } else {
              const ligneCommandeSel = cloneDeep(this.lignesCommande).shift()
                ?.ligneReseau?.lignesCmdSelProduits?.find(lcs => lcs.produitId === face.produitId);
              if (ligneCommandeSel) face.selected = true;
              else face.selected = false;
            }
            return face;
          });
        this.handleSelectedFaces(this.listeFacesBase);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    this.creationDemandeParametre.demandeurId = this.demandeurId;
    this.chargement = true;
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key]);
      await this.initSelFaces();
      if (!this.lignesCommande && !this.demandeLogistique) {
        messageErreur(this.$i18n);
        throw (new Error('Manque paramètre'));
      }
      let devisCommandeId = '';
      if (this.demandeLogistique) {
        this.creationDemandeParametre = cloneDeep(this.demandeLogistique);
        this.creationDemandeParametre.datePlanification = gestionDateBase(
          this.creationDemandeParametre.datePlanification,
        );
        if (this.isProduitIsDivers) {
          devisCommandeId = this.demandeLogistique.ligneCommande?.devisCommandeId
            || this.devisCommandeIdFromLigne;
        }
      } else if (this.devisCommandeIdFromLigne) {
        devisCommandeId = this.devisCommandeIdFromLigne;
      }
      if (devisCommandeId && this.isProduitIsDivers && this.moduleEmplacementClientActive) {
        this.commande = (await getCommande(devisCommandeId)).data.result;
        if (this.commande
          && this.commande?.intervenants.some(intervenant => !!intervenant.annonceur)) {
          const emplacements = (await getAllEmplacement({
            query: {
              clientIds: this.commande?.intervenants.filter(intervenant => !!intervenant.annonceur)
                .map(annonceur => annonceur.tiersId),
              brouillon: null,
              societeId: this.societeActiveId,
            },
            MaxResultCount: this.constantes.NO_PAGINATION,
            SkipCount: 0,
          })).data.result.items;
          this.doAnnonceursHasEmplacementClient = emplacements
            .some(emplacement => emplacement.type === CLIENT && emplacement.dispositifs.length > 0);
        }
      }
      loadingComponent.close();
      this.chargement = false;
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      this.chargement = false;
      throw e;
    }
  },
};
</script>
